export default {
  INPUT_TYPES: {
    BUDGET_CATEGORY_INPUT: 'budgetCategoryInput',
    DELETED_INPUT: 'deletedInput',
    RESOLVED_BUG_INPUT: 'resolvedBugInput',
    PAPAS_MERGE_INPUT: 'papasMergeInput',
    SONS_MERGE_INPUT: 'sonsMergeInput',
    ACCOUNT_INPUT: 'accountInput',
    CANCEL_ENVELOPE_INPUT: 'cancelEnvelopeInput',
    ENRICHMENT_INPUT: 'enrichmentInput',
    CHANGE_ENVELOPE_AMOUNT_INPUT: 'changeEnvelopeAmountInput',
    RISEUP_GOAL_INPUT: 'riseupGoalInput',
    ENVELOPE_EXPENSE_CATEGORY_INPUT: 'envelopeExpenseCategoryInput',
  },
  FEATURE_FLAG_NAMES: {
    STORY_MENU: 'story-menu',
    TRACKING_CATEGORY_CHALLENGE: 'tracking-category-challenge',
    POSITIVE_CHALLENGE_NEW_COPY: 'positive-challenge-new-copy',
    JOIN_AMBASSADORS_INSIGHT: 'elsa-join-ambassadors-insight',
    JOIN_AMBASSADORS_LINK: 'elsa-join-ambassadors-link',
    SAVE_STORY_SHARE: 'save-story-share',
    FIXED_INCOME_USING_ML_MODEL: 'fixed-income-using-ml-model',
    SHARE_PREVIEW_IMAGES: 'share-preview-image',
    CASHFLOW_TRENDS: 'cashflow-trends',
    INTERCOM_AB_TEST: 'intercom_ab_test',
    CASHFLOW_UPDATE_INDICATORS: 'show-cashflow-update-indicators',
    WINE_AND_DINE_SEGMENT_TEST: 'wine-and-dine-segment-test',
    SHOW_POSTPONED_TRANSACTIONS: 'indent-obk-postponed-transaction-budget-date',
    MONEY_BACK_GUARANTEE_TEST: 'money-back-guarantee-test',
    MIGRATION_FROM_PASSWORDS: 'migration-from-passwords',
    PLAN_AHEAD_BETA_GROUP: 'elsa-show-plan-ahead-page',
    SHOW_EDIT_PREDICTED_INCOME: 'show_edit_predicted_income',
  },
  REMOTE_VARIABLES: {
    CASHFLOW_UPDATE_INDICATORS_AGE: 'cashflow-update-indicators-age',
    ISRAEL_BANK_INTEREST: 'israel-bank-interest',
    INFLATION_RATE: 'inflation-rate',
    REFERRALS_ABC_TEST: 'referrals-abc-test',
  },
};
